var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      {
        staticClass: "clearfix",
        attrs: { slot: "header", id: "device-general" },
        slot: "header",
      },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.$t("device.events"))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex justify-between items-center",
            staticStyle: { margin: "7px 0 20px 0" },
          },
          [
            _c(
              "div",
              {
                staticClass: "flex items-center justify-between filter-fields",
                attrs: { "data-info": "filters" },
              },
              [
                _c("el-date-picker", {
                  staticStyle: { "min-width": "400px" },
                  attrs: {
                    size: _vm.btnSize,
                    type: "datetimerange",
                    "picker-options": _vm.pickerOptions,
                    "default-time": ["00:00:00", "23:59:59"],
                    "range-separator": "To",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    align: "right",
                  },
                  model: {
                    value: _vm.eventsRange,
                    callback: function ($$v) {
                      _vm.eventsRange = $$v
                    },
                    expression: "eventsRange",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { size: _vm.btnSize, placeholder: "Type" },
                    model: {
                      value: _vm.filters.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "type", $$v)
                      },
                      expression: "filters.type",
                    },
                  },
                  _vm._l(_vm.eventTypes, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.text, value: item.value },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "font-weight": "400" },
                    attrs: { type: "primary", size: _vm.btnSize },
                    on: {
                      click: function ($event) {
                        return _vm.applyFilters()
                      },
                    },
                  },
                  [_vm._v("\n          Apply filters\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex-none",
                attrs: { "data-info": "filter-controls" },
              },
              [
                _c(
                  "el-button-group",
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Prev page" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: _vm.btnSize,
                              disabled: _vm.disableBackBtn,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveBack()
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-arrow-left" })]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Next page" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: _vm.btnSize,
                              disabled: _vm.disableNextBtn,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.moveFwd()
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-arrow-right" })]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Reset all filters" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: _vm.btnSize },
                            on: {
                              click: function ($event) {
                                return _vm.resetFilters()
                              },
                            },
                          },
                          [_vm._v("\n              Reset\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              "default-sort": { prop: "created_at", order: "descending" },
              data: _vm.eventsFiltered,
              "max-height": "500",
            },
          },
          [
            _c("el-table-column", {
              attrs: { width: "25" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "right",
                            title: "Column Filters",
                            width: "200",
                            trigger: "hover",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "small",
                                "word-break": "break-word",
                                "text-align": "left",
                              },
                              attrs: { slot: "" },
                              slot: "default",
                            },
                            [
                              _vm._v(
                                "\n              Filters at column level don't load new data. They only select from the events already collected.\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-info",
                            staticStyle: { color: "#E6A23C" },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "70" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("font-awesome-icon", {
                            class: {
                              fav: scope.row.is_favorite,
                              "not-fav": !scope.row.is_favorite,
                            },
                            attrs: { icon: "star" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Event ID" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "Event",
                              params: { id: scope.row.ding_id },
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            #" +
                              _vm._s(scope.row.ding_id) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm.needDeviceInfo
              ? _c("el-table-column", {
                  attrs: {
                    prop: "type_desc",
                    filters: _vm.deviceTypes,
                    "filter-method": _vm.filterEventDeviceType,
                    sortable: "",
                    label: "Device Type",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "7px",
                                  "word-break": "break-word",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.defaultTo(
                                        scope.row.type_desc,
                                        scope.row.metadata.device_id
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1350034886
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.needDeviceInfo
              ? _c("el-table-column", {
                  attrs: { label: "Device Name" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "Device",
                                    params: {
                                      doorbot_id: scope.row.doorbot_id,
                                    },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.defaultTo(
                                        scope.row.device_name,
                                        scope.row.doorbot_id
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    200911118
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "Date",
                prop: "created_at",
                sortable: "",
                width: "250",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        [
                          _c("time-zone-formatter", {
                            attrs: { "current-time": scope.row.created_at },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Type", width: "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("capitalize")(scope.row.type))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "status",
                width: "150",
                sortable: "",
                prop: "metadata.status",
                filters: _vm.eventStatuses,
                "filter-method": _vm.filterEventStatus,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", { class: scope.row.metadata.status }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(scope.row.metadata.status)
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }